import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core/';
import { useSelector } from 'react-redux';

import { stylingHelpers } from '../designTokens';
import { CloseApp, Image, NotificationBar, Spacing } from '../components';
import NavMenuBuilder from './NavMenuBuilder';

const { flexCenter } = stylingHelpers;

const baseStyles = ({ theme }) => css`
  background-color: ${theme.colors.black};
  min-height: 51px;
  padding-top: env(safe-area-inset-top);
  padding-top: constant(safe-area-inset-top);

  ${flexCenter()}
  flex-wrap: wrap;
`;

const Container = styled('div')(baseStyles);

const headerRowBaseStyles = () => css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
`;

const headerRowCenteredStyles = ({ centered }) =>
  centered &&
  css`
    justify-content: center;
  `;

const HeaderRow = styled('div')(headerRowBaseStyles, headerRowCenteredStyles);

const closeContainerBaseStyles = () => css``;

const CloseContainer = styled('div')(closeContainerBaseStyles);

const imageContainerBaseStyles = () => css`
  max-width: 170px;
  margin: 0 auto;
`;

const ImageContainer = styled('div')(imageContainerBaseStyles);

const spacerBaseStyles = () => css`
  width: 30px;
  visibility: hidden;
`;

const Spacer = styled('div')(spacerBaseStyles);

const TimsHeader = ({
  showClose,
  showNav,
  closeUrl,
  logoUrl,
  hasNotificationAlert,
  notificationBarTitle,
  notificationBarText,
  handleNotificationBarCloseClick,
  prefix: PrefixComponent,
  ...props
}) => {
  const { strings } = useSelector((state) => state);
  const logoAlt = strings['roles/img/hockeyChallengeLogo/alt'];
  const hasCloseWithNoLogo = showClose && !logoUrl;

  return (
    <Container>
      {logoUrl && (
        <Spacing sizeLeft='mega' sizeRight='mega' sizeTop='kilo' sizeBottom='kilo'>
          <HeaderRow>
            {showClose && (
              <CloseContainer>
                <CloseApp href={closeUrl} />
              </CloseContainer>
            )}
            <ImageContainer>
              <Image alt={logoAlt} src={logoUrl} />
            </ImageContainer>
            {PrefixComponent && <PrefixComponent />}
          </HeaderRow>
        </Spacing>
      )}

      {showNav && (
        <Spacing>
          <HeaderRow centered={!showClose || logoUrl}>
            {hasCloseWithNoLogo && (
              <CloseContainer>
                <CloseApp href={closeUrl} />
              </CloseContainer>
            )}
            <NavMenuBuilder {...props} />
            {hasCloseWithNoLogo && <Spacer />}
          </HeaderRow>
        </Spacing>
      )}

      {hasNotificationAlert && (
        <HeaderRow>
          <NotificationBar
            title={notificationBarTitle}
            text={notificationBarText}
            onSelect={handleNotificationBarCloseClick}
            size='tera'
          />
        </HeaderRow>
      )}
    </Container>
  );
};

TimsHeader.propTypes = {
  showClose: PropTypes.bool,
  showNav: PropTypes.bool,
  closeUrl: PropTypes.string,
  logoUrl: PropTypes.string,
  hasNotificationAlert: PropTypes.bool,
  notificationBarTitle: PropTypes.string,
  notificationBarText: PropTypes.string,
  handleNotificationBarCloseClick: PropTypes.func,
  prefix: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
};

TimsHeader.defaultProps = {
  closeUrl: 'timhortons:///',
  showClose: false,
};

export default TimsHeader;
